import { render } from "./CustomTab.vue?vue&type=template&id=8ea1efac"
import script from "./CustomTab.vue?vue&type=script&lang=js"
export * from "./CustomTab.vue?vue&type=script&lang=js"
script.render = render

export default script